import { ClientWebCore } from './ClientWebCore';
import { Routes, Route } from 'react-router-dom';
import { Start } from './components/Start';
import { lazy } from 'react';
import { ClientWebStyles } from './styles/ClientWebStyles';

const Carta = lazy(() => import('./cores/Carta'));

interface Props {
  config: typeof ClientWebCore.config;
}

export function ClientWebCoreEntrypoint(props: Props) {
  ClientWebCore.init(props.config);
  return (
    <ClientWebStyles>
      <Routes>
        <Route element={<Carta />} path="/carta/*" />
        <Route element={<Start />} path="/" />
      </Routes>
    </ClientWebStyles>
  );
}
